import { useRootDishCategoryBySlugQuery } from '~/libs/gql/queries/root_dish_categories/rootDishCategoryBySlugQuery.generated';

export const useRootDishCategoryBySlugData = ({ slug }: { slug: string }) => {
  const query = useRootDishCategoryBySlugQuery({
    variables: {
      slug,
    },
  });
  return query;
};
